'use client';
import React from 'react';
import { Col, Container, Placeholder, Row } from 'react-bootstrap';

export default function BlogComponentSkeleton() {
  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
        <Col md={4} xs={12} sm={6} lg={4}>
          <Placeholder
            xs={12}
            style={{ height: '229px', marginBottom: '20px' }}
          />
        </Col>
      </Row>
    </Container>
  );
}
